import { Form } from '@homex/se-react-components';
import styled, { css } from 'styled-components/macro';

import { ThemedCircleButton } from 'components/ThemedCircleButton';
import { ReactComponent as AddSvg } from 'components/svg/MediaUploadAdd.svg';
import { large, medium } from 'styles/breakpoints';
import { container, containerTall } from 'styles/layout';
import { error, headingLower, inputSmall, paragraph } from 'styles/typography';
import { IWithThemeProps } from 'typings';

interface IBoxContainerProps {
  isDisabled: boolean;
}

interface ITextUpperDesktopProps {
  hasFiles: boolean;
}

interface IUploadContainerProps {
  isDraggingOver: boolean;
}

const desktopOnly = css`
  display: none;

  ${large`
    display: block;
  `}
`;

const mobileOnly = css`
  display: block;

  ${large`
    display: none;
  `}
`;

export const CellphoneImage = styled.img`
  height: 116px;
  width: 241px;
`;

export const ButtonsMobile = styled.div`
  ${container}
  ${mobileOnly}
`;

export const FormGroup = styled(Form)`
  ${containerTall}
`;

export const DesktopHeader = styled.div`
  ${container}
  ${desktopOnly}

  margin-top: 25px;

  ${large`
    padding-right: 0;
  `}
`;

export const LowerHeader = styled.h1`
  ${headingLower}

  margin-bottom: 13px;
  margin-top: 9px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

export const UploadContainer = styled.div<IUploadContainerProps>`
  border: 0;
  margin: 0 auto;
  padding: 23px 9px 0;
  position: relative;
  width: 100%;

  ${medium`
    width: 333px;
  `}

  ${({ theme }: IWithThemeProps) => large`
    border: 1px dashed ${theme.mediaUploadActionItemColor};
    border-radius: 6px;
    padding: 23px 21px;
    width: 100%;
  `}

  ${({ isDraggingOver }) => {
    if (isDraggingOver) {
      return large`
        border-width: 2px;
        padding: 22px 20px;
      `;
    }

    return '';
  }}
`;

export const UploadBoxContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
`;

const textUpperBaseStyles = css`
  ${paragraph}

  margin: 0 auto 20px;
  max-width: 100%;
  width: 490px;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundPrimary};
  `}
`;

const textUpperFilesStyles = css`
  ${textUpperBaseStyles}
  ${error}

  border-radius: 3px;
  padding: 14px 10px;
  text-align: center;
  width: 567px;

  ${({ theme }: IWithThemeProps) => `
    background-color: ${theme.mediaUploadActionItemColor};
    border: 1px solid ${theme.mediaUploadActionItemColor};
    color: ${theme.topForegroundPrimary};
  `}
`;

export const TextUpperDesktop = styled.p<ITextUpperDesktopProps>`
  ${desktopOnly}

  ${({ hasFiles }) => (hasFiles ? textUpperFilesStyles : textUpperBaseStyles)}
`;

export const TextUpperMobile = styled.p`
  ${mobileOnly}
  ${textUpperBaseStyles}
`;

export const TextLowerMobile = styled.p`
  ${textUpperBaseStyles}

  margin: 0 auto;
`;

export const DropzoneDivStyled = styled.div`
  border: 0;
  cursor: pointer;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
`;

export const BoxContainer = styled.div<IBoxContainerProps>`
  ${({ isDisabled }) => {
    if (isDisabled) {
      return `
        pointer-events: none;
      `;
    }

    return '';
  }}
`;

const buttonStyles = css`
  ${container}

  margin-top: 8px;
`;

export const ButtonsDesktop = styled.div`
  ${buttonStyles}
  ${desktopOnly}
`;

export const SkipButtonMobile = styled.button`
  ${buttonStyles}
  ${mobileOnly}
  ${inputSmall}

  background: transparent;
  border: none;
  cursor: pointer;
  text-transform: uppercase;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.bottomForegroundActionPrimary};
  `}
`;

export const CircleButtonStyled = styled(ThemedCircleButton)`
  margin: 30px auto;
`;

export const TextLower = styled.p`
  ${desktopOnly}
  ${inputSmall}

  padding: 20px 0 0 0;
  text-align: center;
  text-transform: uppercase;

  ${({ theme }: IWithThemeProps) => `
    color: ${theme.mediaUploadActionItemColor};
  `}
`;

export const AddSvgStyled = styled(AddSvg)`
  ${({ theme }: IWithThemeProps) => `
    [data-svg-class="Stroke"] {
      stroke: ${theme.bottomForegroundActionPrimary};
    }
  `}
`;
